var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGenset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fill-icon{fill:currentColor;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Genset"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fill-icon",
    d: "M16.5,82.35v30.76h97V68.16Zm29,14.79H28.92V90H45.48Zm27.21,0H57.31V90H72.69Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fill-icon",
    points: "92.8 43.91 101.08 43.91 103.44 66.38 92.8 67.57 92.8 43.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fill-icon",
    points: "72.69 39.18 82.15 39.18 82.15 69.93 72.69 71.12 72.69 39.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fill-icon",
    points: "33.65 59.29 56.13 59.29 60.86 72.3 26.55 78.21 33.65 59.29"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fill-icon",
    x: 33.06,
    y: 49.82,
    width: 23.07,
    height: 5.91
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fill-icon",
    points: "45.21 14.93 55.09 14.93 46.69 27.78 54.1 28.27 38.78 46.56 44.71 31.73 37.79 31.73 45.21 14.93"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenset);
export default __webpack_public_path__ + "static/media/genset.e1c95d2e3844554bf53afb2bc8d7f948.svg";
export { ForwardRef as ReactComponent };